import "./Market.module.css";
import Header from "@/reusable_sections/Header";
import MarketTreasures from "./sections/MarketTreasures";
import ImportedExcellence from "./sections/ImportedExcellence";
import NewArrivals from "./sections/NewArrivals";
import Footer from "@/reusable_sections/Footer";
export default function MarketPage() {
  return <div>
      <Header />
      <MarketTreasures />
      <ImportedExcellence />
      <NewArrivals />
      <Footer />
    </div>;
}